import TaxInfoModal from './tax-info-modal';

export default TaxInfoModal;
